import React from 'react'
import Popup from "./Popup";
import SearchTable from "./SearchTable"

// SearchPopupButton Component
export default class SearchPopupButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            visible : false
            //,tableRef:React.createRef()
        }
    }    
    componentDidMount(prevProps) {

    }
    componentDidUpdate(prevProps) {
        //if(this.state.visible){
        //    this.state.tableRef.current.defaultCursor(); 
        //}
     }
    
    // render
    render() {
        return(true) ? (
            <span className="search-popup">
                <button 
                    onClick={this.openPopup.bind(this)}
                    hidden={this.props.hidden}
                    disabled={this.props.disabled}
                    className={this.props.className}
                    >
                        {this.props.buttonLabel}
                </button>
                <Popup className="search-popup" trigger={ this.state.visible }  >
                    <div className="align-right">
                        <button className="close-btn" onClick={() => this.closePopup() }>x</button>
                    </div>
                    <h3>{this.props.title}</h3>
                     <SearchTable
                        securityObject={this.props.securityObject}
                        query={this.props.query}
                        columns={this.props.columns}
                        onClick={this.selectRow.bind(this)}
                        tableHeight="40vh"
                        openSearched={this.props.openSearched}
                    >
                    </SearchTable>
                </Popup>
            </span>
        ) :"";
    }
    openPopup(){
        this.setState({
            visible:true
        });
        if(this.props.onDislpayPopup){
            this.props.onDislpayPopup();
        }
        
    }
    closePopup(){
        this.setState({
            visible:false
        });  
        if(this.props.onClosePopup){
            this.props.onClosePopup();
        }
    }
    selectRow( rowData, rowIndex ){
        if(this.props.onClick){
            this.props.onClick(rowData);
        }
        this.closePopup();
    }
}

